<template>
    <b-card title="Laboratory" sub-title="Information about laboratory">
      <b-row>
        <b-col cols="12">
          <b-form-group
            label="Creatinin"
            label-for="creatinin"
            label-cols-md="4"
          >
            <b-form-input
              v-model="patientInfo.follow_up_lab_creatinin"
              id="creatinin"
              type="number"
              placeholder="Creatinin"
              :readonly="readOnly"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group
            label="GFR"
            label-for="gfr"
            label-cols-md="4"
          >
            <b-form-input
              v-model="patientInfo.follow_up_lab_GFR"
              id="gfr"
              type="number"
              placeholder="GFR"
              :readonly="readOnly"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group
            label="NT pro BNP"
            label-for="nt_pro"
            label-cols-md="4"
          >
            <b-form-input
              v-model="patientInfo.follow_up_lab_NT_proBNP"
              id="nt_pro"
              type="number"
              placeholder="NT pro BNP"
              :readonly="readOnly"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group
            label="gammaGT"
            label-for="gamma_gt"
            label-cols-md="4"
          >
            <b-form-input
              v-model="patientInfo.follow_up_lab_gammaGT"
              id="gamma_gt"
              type="number"
              placeholder="gammaGT"
              :readonly="readOnly"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group
            label="GOT"
            label-for="got"
            label-cols-md="4"
          >
            <b-form-input
              v-model="patientInfo.follow_up_lab_GOT"
              id="got"
              type="number"
              placeholder="GOT"
              :readonly="readOnly"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group
            label="HB"
            label-for="hb"
            label-cols-md="4"
          >
            <b-form-input
              v-model="patientInfo.follow_up_lab_hb"
              id="hb"
              type="number"
              placeholder="HB"
              :readonly="readOnly"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group
            label="Troponin"
            label-for="troponin"
            label-cols-md="4"
          >
            <b-form-input
              v-model="patientInfo.follow_up_lab_troponin"
              id="troponin"
              type="number"
              placeholder="Troponin"
              :readonly="readOnly"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group
            label="Bilirubin"
            label-for="bilirubin"
            label-cols-md="4"
          >
            <b-form-input
              v-model="patientInfo.follow_up_lab_bilirubin"
              id="bilirubin"
              type="number"
              placeholder="Bilirubin"
              :readonly="readOnly"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group
            label="Albumin"
            label-for="albumin"
            label-cols-md="4"
          >
            <b-form-input
              v-model="patientInfo.follow_up_lab_albumin"
              id="albumin"
              type="number"
              placeholder="Albumin"
              :readonly="readOnly"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group
            label="INR"
            label-for="inr"
            label-cols-md="4"
          >
            <b-form-input
              v-model="patientInfo.follow_up_lab_inr"
              id="inr"
              type="number"
              placeholder="INR"
              :readonly="readOnly"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </b-card>
</template>

<script>
import {
  BRow, BCol, BCard, BFormGroup, BFormInput, BInputGroup, BInputGroupAppend, BFormDatepicker
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { mapState } from 'vuex'

export default {
  components: {
    BRow, BCol, BCard, BFormGroup, BFormInput, BInputGroup, BInputGroupAppend, BFormDatepicker,
    vSelect
  },
  data() {
    return {
      patientInfo: {
        _id: null,
        follow_up_lab_creatinin: '',
        follow_up_lab_GFR: '',
        follow_up_lab_NT_proBNP: '',
        follow_up_lab_gammaGT: '',
        follow_up_lab_GOT: '',
        follow_up_lab_hb: '',
        follow_up_lab_troponin: '',
        follow_up_lab_bilirubin: '',
        follow_up_lab_albumin: '',
        follow_up_lab_inr: '',
      }
    }
  },
  computed: {
    ...mapState('patient', ['patient', 'role']),
    readOnly() {
      return this.role == 'viewer' || this.role == ''
    },
  },
  watch: {
		patient(v, ov) {
      if (v._id) {
        this.setPatientInfo(v)
      }
		},
  },
  mounted() {
    if (this.patient._id) {
      this.setPatientInfo(this.patient)
    }
  },
  methods: {
    setPatientInfo(v) {
      this.patientInfo._id = v._id
      this.patientInfo.follow_up_lab_creatinin = v.follow_up_lab_creatinin
      this.patientInfo.follow_up_lab_GFR = v.follow_up_lab_GFR
      this.patientInfo.follow_up_lab_NT_proBNP = v.follow_up_lab_NT_proBNP
      this.patientInfo.follow_up_lab_gammaGT = v.follow_up_lab_gammaGT
      this.patientInfo.follow_up_lab_GOT = v.follow_up_lab_GOT
      this.patientInfo.follow_up_lab_hb = v.follow_up_lab_hb
      this.patientInfo.follow_up_lab_troponin = v.follow_up_lab_troponin
      this.patientInfo.follow_up_lab_bilirubin = v.follow_up_lab_bilirubin
      this.patientInfo.follow_up_lab_albumin = v.follow_up_lab_albumin
      this.patientInfo.follow_up_lab_inr = v.follow_up_lab_inr
    }
  }
}
</script>

<style>

</style>
